import { NgModule } from '@angular/core';
import { Selectbox } from './selectbox';
import { FormsModule } from '@angular/forms';
import { IconModule } from '../../icon/icon.module';
import { MatIconModule } from '@angular/material/icon';
import { TextboxModule } from '../textbox/textbox.module';

@NgModule({
    declarations: [Selectbox],
    exports: [Selectbox],
    imports: [FormsModule, IconModule, MatIconModule, TextboxModule],
})
export class SelectboxModule {
}